var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.548737 6.30765C0.548737 2.80823 3.45517 0 7.00001 0C10.5448 0 13.4512 2.80823 13.4512 6.30765C13.4512 9.80707 10.5448 12.6153 7.00001 12.6153C3.45517 12.6153 0.548737 9.80707 0.548737 6.30765ZM7.00001 1.53845C4.26797 1.53845 2.08718 3.69429 2.08718 6.30765C2.08718 8.92099 4.26797 11.0768 7.00001 11.0768C9.73205 11.0768 11.9128 8.92099 11.9128 6.30765C11.9128 3.69429 9.73205 1.53845 7.00001 1.53845Z",
    fill: "#34415A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4667 19.5805C9.96639 15.5681 3.96212 15.5903 1.50331 19.6306C1.28239 19.9935 0.809178 20.1086 0.44627 19.8877C0.0833674 19.6669 -0.0317827 19.1937 0.189077 18.8307C3.24711 13.8061 10.6746 13.7856 13.7762 18.7732L13.7827 18.7836L13.8134 18.8349C14.032 19.1992 13.9138 19.6717 13.5496 19.8903C13.1853 20.1088 12.7128 19.9907 12.4942 19.6264L12.4667 19.5805Z",
    fill: "#34415A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.f55e35ab92fe44c174e9c3eb2bb55047.svg";
export { ForwardRef as ReactComponent };